import { c as _c } from "react/compiler-runtime";
/**
 * @file FormComponent.tsx
 * @description
 * -----------------------------------------------------
 * Componente de formularios de Next.js
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-04-09
 * @modified 2025-07-21
 * @author DLTCode
 * @author Mohammed Derfoufi
 * @author Ismael Benabdellah
 * @author Nacho Moya
 * @copyright © DLTCode
 * @license Private
 * */

import { FormComponentProps } from "@/types/forms/forms";
import { FormEventHandler, startTransition } from "react";
import SubmitButtonComponent from "./SubmitButtonComponent";
const FormComponent = t0 => {
  const $ = _c(15);
  const {
    formAction,
    formClassName,
    children,
    formData,
    buttonSubmit: t1,
    buttonSubmitText: t2,
    buttonClassName,
    icon,
    iconProps,
    loading
  } = t0;
  const buttonSubmit = t1 === undefined ? false : t1;
  const buttonSubmitText = t2 === undefined ? "buttonSearch" : t2;
  let t3;
  if ($[0] !== formAction) {
    t3 = event => {
      event.preventDefault();
      const formData_0 = new FormData(event.target as HTMLFormElement);
      startTransition(() => formAction(formData_0));
    };
    $[0] = formAction;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleSubmit = t3;
  let t4;
  if ($[2] !== buttonClassName || $[3] !== buttonSubmit || $[4] !== buttonSubmitText || $[5] !== formData || $[6] !== icon || $[7] !== iconProps || $[8] !== loading) {
    t4 = buttonSubmit && formData && <SubmitButtonComponent buttonLabel={buttonSubmitText} className={buttonClassName} loading={loading} icon={icon} iconProps={iconProps} />;
    $[2] = buttonClassName;
    $[3] = buttonSubmit;
    $[4] = buttonSubmitText;
    $[5] = formData;
    $[6] = icon;
    $[7] = iconProps;
    $[8] = loading;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== children || $[11] !== formClassName || $[12] !== handleSubmit || $[13] !== t4) {
    t5 = <form className={formClassName} onSubmit={handleSubmit}>{children}{t4}</form>;
    $[10] = children;
    $[11] = formClassName;
    $[12] = handleSubmit;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default FormComponent;